/**
 * Custom JS — Borderline Theme
 * Loaded after theme.js. Uses event delegation.
 */
(function () {
  'use strict';

  var initialized = false;

  function closeAllNavs() {
    document.querySelectorAll('.header-navigation .menu-item.nav-open').forEach(function (el) {
      el.classList.remove('nav-open');
      var a = el.querySelector(':scope > .menu-link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }

  function closeSiblingNavs(item) {
    var siblings = item.parentNode.querySelectorAll(':scope > .menu-item.nav-open');
    siblings.forEach(function (el) {
      el.classList.remove('nav-open');
      var a = el.querySelector(':scope > .menu-link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }

  function initClickNav() {
    if (initialized) return;
    initialized = true;

    document.addEventListener('click', function (e) {
      if (window.innerWidth < 992) return;

      // R2-NAV: restrict click-to-open toggle to TOP-LEVEL nav items only, so that
      // deeper mega links (column headings, type items) navigate normally.
      var link = e.target.closest('.header-navigation > .menu-item > .menu-link.has-children');
      if (!link) {
        // Clicked outside nav → close all
        if (!e.target.closest('.header-navigation')) {
          closeAllNavs();
        }
        return;
      }

      e.preventDefault();

      var item = link.parentNode;
      var isOpen = item.classList.contains('nav-open');

      if (isOpen) {
        // OPEN: click toggles the panel closed (including any open descendants).
        item.classList.remove('nav-open');
        link.setAttribute('aria-expanded', 'false');
        item.querySelectorAll('.menu-item.nav-open').forEach(function (el) {
          el.classList.remove('nav-open');
          var a = el.querySelector(':scope > .menu-link');
          if (a) a.setAttribute('aria-expanded', 'false');
        });
      } else {
        // CLOSED: click toggles the panel open and closes siblings.
        closeSiblingNavs(item);
        item.classList.add('nav-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllNavs();
    });
  }

  document.addEventListener('DOMContentLoaded', initClickNav);
})();

/* ---- R67: 共享 /cart.js 单飞取数 ----
   免邮条(此文件)与 PDP 免邮 nudge(bl-ship-nudge)此前在同一次购物车变动的 debounce 窗口内
   各自 fetch 一遍 /cart.js(评审 K7)。800ms 记忆窗内共用一个在途 promise, 两路并一路。 */
/* R75(上线前审查): fresh=true 跳过记忆窗强制新拉(并刷新 memo 供并发方共享) ——
   连续快速加减件时, 变更后的刷新若命中变更前发起的 promise 会把陈旧件数/免邮文案写回
   (审查实锤时序: 两击 0.3-0.5s 间隔)。变更驱动的刷新(fsb refreshBars)一律 fresh。 */
window.blCartFetch = function (fresh) {
  var now = Date.now();
  if (!fresh && window.__blCartP && (now - (window.__blCartT || 0)) < 800) { return window.__blCartP; }
  window.__blCartT = now;
  window.__blCartP = fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); });
  return window.__blCartP;
};

/**
 * Free shipping progress bar.
 * The bar is server-rendered (snippets/free-shipping-bar.liquid). This script
 * keeps it in sync when the cart changes (quantity edits, item removal) by
 * watching the cart drawer / cart page for mutations and re-reading /cart.js.
 */
(function () {
  'use strict';

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function withThousands(str, sep) {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  // Mirror Shopify's money_format token replacement for common token types.
  function formatMoney(cents, format) {
    var value = Math.max(0, cents) / 100;
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
      switch (token) {
        case 'amount':
          return withThousands(value.toFixed(2), ',');
        case 'amount_no_decimals':
          return withThousands(Math.round(value).toString(), ',');
        case 'amount_with_comma_separator':
          return withThousands(value.toFixed(2).replace('.', ','), '.');
        case 'amount_no_decimals_with_comma_separator':
          return withThousands(Math.round(value).toString(), '.');
        case 'amount_with_space_separator':
          return withThousands(value.toFixed(2).replace('.', ','), ' ');
        case 'amount_with_apostrophe_separator':
          return withThousands(value.toFixed(2), "'");
        default:
          return withThousands(value.toFixed(2), ',');
      }
    });
  }

  function getLineFinalPrice(item) {
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    return 0;
  }

  function getEligibleCartTotal(cart, bar) {
    var excludedIds = bar.getAttribute('data-excluded-variant-ids') || '';
    var excludedTotal = 0;
    var hasExcludedItems = false;

    (cart.items || []).forEach(function (item) {
      var marker = '|' + (item.variant_id || item.id) + '|';
      if (excludedIds.indexOf(marker) !== -1) {
        hasExcludedItems = true;
        excludedTotal += getLineFinalPrice(item);
      }
    });

    return {
      total: Math.max(0, (cart.total_price || 0) - excludedTotal),
      hasExcludedItems: hasExcludedItems
    };
  }

  /* R73(GWP 满送 8/24-8/30): 进度条档位模式。gwp_active(主题设置)开 或 ?blgwp=1(QA 钩子)
     且 无超大件 且 全车值>=免邮线 → 文案切赠品档位($150 桶/$300 凳/$500 礼品卡), fill 按
     下一档进度。档位金额=discount 的 minimum subtotal 口径(全车值, 不剔超大件——运费口径
     才剔)。超大件车保持 $30 note 原逻辑不进档位模式。 */
  /* R94(运营工单 2026-08-29): 满赠切礼品卡版(至 9/7) —— $15/$25/$50 三档, 互斥取最高 */
  var GWP_TIERS = [
    { min: 15000, tpl: "You're [amount] away from a free $15 gift card 🎁" },
    { min: 30000, tpl: '$15 card unlocked! [amount] more for the $25 gift card' },
    { min: 50000, tpl: '$25 card unlocked! [amount] more for the $50 gift card' }
  ];
  var GWP_DONE = 'All tiers unlocked — grab your free $50 gift card 🎉';
  function gwpEnabled(bar) {
    if (/[?&]blgwp=1/.test(location.search)) return true;
    return bar.getAttribute('data-gwp') === '1';
  }
  /* R76: 免邮状态微行 + 解锁档一键加赠品按钮(老板对稿: 免邮信息不消失 + 要一键加车) */
  /* R92(老板需求"购物车加角落表那种可选功能"): R76 单按钮/done/gc-line 三件套退役,
     抽屉进度条内嵌三档选择列表(bl-gwp-tiers snippet), 状态由 syncTiers 统一管理。 */
  function gwpExtras(bar, fullTotal, cart, noFsOk) {
    var fsok = bar.querySelector('[data-fsb-fsok]');
    if (fsok) fsok.hidden = !!noFsOk; /* R79: 超大件车不免邮 —— 绿勾微行不显示 */
    var tiers = bar.querySelector('[data-gwp-tiers]');
    if (tiers) syncTiers(tiers, cart, fullTotal);
  }
  /* R92 建 / R94 卡版重写: 通用三档状态机(fab 面板与抽屉列表共用)。fullTotal = 剔赠品后
     的资格金额。三档全是礼品卡变体, 互斥取最高(运营工单): 只引导当前最高解锁档 ——
     目标档行给 [Add free](无卡在车)或 [Upgrade/Swap](有别的卡 → 替换); 持有目标档 = ✓;
     被超过的低档 = 静态 Unlocked; 未到 = 锁定。卡不追踪库存, 无售罄态。
     持有卡但掉档(卡变全价)的场景由哨兵 gwpGiftWarn 警示, 不在此处。 */
  function syncTiers(root, cart, fullTotal) {
    if (!root || !cart) return;
    var bar = document.querySelector('[data-free-shipping-bar]');
    var g1 = null, g2 = null, g3 = null;
    if (bar) {
      g1 = bar.getAttribute('data-gwp-g1'); g2 = bar.getAttribute('data-gwp-g2');
      g3 = bar.getAttribute('data-gwp-g3');
    }
    var giftInCart = false, inCartId = null;
    (cart.items || []).forEach(function (it) {
      var vid = String(it.variant_id);
      if (vid === g1 || vid === g2 || vid === g3) { giftInCart = true; inCartId = vid; }
    });
    var cur = fullTotal >= 50000 ? 3 : fullTotal >= 30000 ? 2 : fullTotal >= 15000 ? 1 : 0;
    var rowGiftIds = { 1: g1, 2: g2, 3: g3 };
    for (var t = 1; t <= 3; t++) {
      var row = root.querySelector('[data-fab-tier="' + t + '"]');
      if (!row) continue;
      var state = row.querySelector('[data-fab-state]');
      var add = row.querySelector('[data-fsb-gift]');
      var swap = row.querySelector('[data-fsb-swap]');
      var txt = '', showAdd = false, showSwap = false, cls = '';
      if (cur < t) {
        txt = 'Unlock at $' + (t === 1 ? '150' : t === 2 ? '300' : '500');
      } else if (t < cur) {
        txt = 'Unlocked'; /* 被更高档取代, 只引导最高档 */
      } else { /* t === cur: 目标档 */
        /* R98(审查): rowGiftIds[t] 非空守卫 —— 页面无进度条(免邮条关/未渲染)时 g 全 null,
           null===null 会假显示"已在车"且藏掉按钮 */
        if (rowGiftIds[t] && inCartId === rowGiftIds[t]) { txt = '✓ In cart — free at checkout'; cls = 'is-on'; }
        else if (giftInCart) { txt = ''; showSwap = true; /* 升/换档: 替换车里的旧卡 */ }
        else { txt = ''; showAdd = true; }
      }
      if (state) { state.textContent = txt; state.hidden = txt === ''; state.className = 'bl-gwp-fab__tstate' + (cls ? ' ' + cls : ''); }
      if (add) add.hidden = !showAdd;
      if (swap) swap.hidden = !showSwap;
    }
  }
  /* R77(老板对稿): 赠品哨兵 —— 折扣是逐次重评估的(实测: 升档后先加的桶被重评为 $14.99):
     掉档/双赠品/换档场景里车里的赠品会静默变全价。开关开即检测(独立于当前车值档位),
     命中=琥珀警示行+一键移除(按 line key 精确删行)。 */
  function gwpGiftWarn(bar, cart) {
    var warn = bar.querySelector('[data-fsb-warn]');
    if (!warn) return;
    if (!gwpEnabled(bar) || !cart || !cart.items) { warn.hidden = true; return; }
    var g1 = bar.getAttribute('data-gwp-g1'), g2 = bar.getAttribute('data-gwp-g2'), g3 = bar.getAttribute('data-gwp-g3');
    var giftLines = [], paid = null;
    for (var i = 0; i < cart.items.length; i++) {
      var vid = String(cart.items[i].variant_id);
      if (vid === g1 || vid === g2 || vid === g3) {
        giftLines.push(cart.items[i]);
        if (cart.items[i].final_line_price > 0 && !paid) paid = cart.items[i];
      }
    }
    if (!paid) { warn.hidden = true; return; }
    var txtEl = bar.querySelector('[data-fsb-warn-text]');
    var rmBtn = bar.querySelector('[data-fsb-warn-remove]');
    var moneyFormat = bar.getAttribute('data-money-format') || (window.btyGlobals && window.btyGlobals.money_format);
    var amt = formatMoney(paid.final_line_price, moneyFormat);
    var msg;
    var warnEligible = cart.total_price || 0;
    for (var w = 0; w < giftLines.length; w++) { warnEligible -= giftLines[w].final_line_price || 0; }
    if (giftLines.length > 1) {
      msg = 'One gift per order — the extra gift is charging full price (' + amt + '). Remove it below.';
    } else if (warnEligible < 15000) {
      msg = 'Your cart dropped under $150 — the gift now charges full price (' + amt + '). Add more gear or remove it.';
    } else {
      msg = 'Your gift tier changed — this gift now charges full price (' + amt + '). Remove it below.';
    }
    if (txtEl && txtEl.textContent !== msg) txtEl.textContent = msg;
    if (rmBtn) rmBtn.setAttribute('data-remove-key', paid.key);
    warn.hidden = false;
  }
  function hideGwpExtras(bar) {
    var fsok = bar.querySelector('[data-fsb-fsok]');
    var btn = bar.querySelector('[data-fsb-gift]');
    var done = bar.querySelector('[data-fsb-gift-done]');
    var gcLine = bar.querySelector('[data-fsb-gc-line]');
    if (fsok) fsok.hidden = true;
    if (btn) btn.hidden = true;
    if (done) done.hidden = true;
    if (gcLine) gcLine.hidden = true;
  }
  function applyGwp(bar, fullTotal, cart, noFsOk) {
    var fill = bar.querySelector('[data-fsb-fill]');
    var textEl = bar.querySelector('[data-fsb-text]');
    if (!textEl) return;
    bar.classList.add('is-gwp');
    gwpExtras(bar, fullTotal, cart, noFsOk);
    var tier = null;
    for (var i = 0; i < GWP_TIERS.length; i++) { if (fullTotal < GWP_TIERS[i].min) { tier = GWP_TIERS[i]; break; } }
    if (!tier) {
      bar.classList.add('is-reached');
      if (fill) fill.style.width = '100%';
      if (textEl.textContent !== GWP_DONE) textEl.textContent = GWP_DONE;
      textEl._fsbLast = null;
      return;
    }
    bar.classList.remove('is-reached');
    var pct = Math.min(100, Math.max(0, Math.round((fullTotal / tier.min) * 100)));
    if (fill) fill.style.width = pct + '%';
    var moneyFormat = bar.getAttribute('data-money-format') || (window.btyGlobals && window.btyGlobals.money_format);
    var amount = formatMoney(tier.min - fullTotal, moneyFormat);
    var html = escapeHtml(tier.tpl).replace('[amount]', '<span class="fsb-amount">' + amount + '</span>');
    if (textEl._fsbLast !== html) { textEl._fsbLast = html; textEl.innerHTML = html; }
  }
  function updateBar(bar, totalCents, hasExcludedItems, gwpCart) {
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) return;
    var fullTotal = gwpCart && typeof gwpCart.total_price === 'number' ? gwpCart.total_price : undefined;
    /* R78: 低车值活动提示行 —— gwp 开且全车值未达免邮线时显示(达线后档位文案接管) */
    var gwpHint = bar.querySelector('[data-fsb-gwp-hint]');
    if (gwpHint) gwpHint.hidden = !(gwpEnabled(bar) && typeof fullTotal === 'number' && fullTotal < threshold && fullTotal > 0);

    if (!hasExcludedItems && typeof fullTotal === 'number' && fullTotal >= threshold && gwpEnabled(bar)) {
      var noteEl0 = bar.querySelector('[data-fsb-note]');
      var textEl0 = bar.querySelector('[data-fsb-text]');
      var trackEl0 = bar.querySelector('[data-fsb-track]');
      if (noteEl0) noteEl0.hidden = true;
      if (textEl0) textEl0.hidden = false;
      if (trackEl0) trackEl0.hidden = false;
      applyGwp(bar, fullTotal, gwpCart);
      return;
    }
    /* R79(老板对稿"oversized 覆盖了礼品"): 超大件车赠品资格照在(折扣按全车值判定) ——
       $30 note 保留, 下方叠加档位文案+加赠按钮; 免邮绿勾不显示(超大件确实不免邮)。
       SSR 仍是 note-only, 首刷/观察器由本分支接管(init 首刷条件已含 data-gwp)。 */
    if (hasExcludedItems && gwpEnabled(bar) && typeof fullTotal === 'number' && fullTotal >= 15000) {
      var noteEl2 = bar.querySelector('[data-fsb-note]');
      var textEl2 = bar.querySelector('[data-fsb-text]');
      var trackEl2 = bar.querySelector('[data-fsb-track]');
      if (noteEl2) noteEl2.hidden = false;
      if (textEl2) textEl2.hidden = false;
      if (trackEl2) trackEl2.hidden = false;
      applyGwp(bar, fullTotal, gwpCart, true);
      return;
    }
    bar.classList.remove('is-gwp');
    hideGwpExtras(bar);

    var remaining = threshold - totalCents;
    var percent = Math.min(100, Math.max(0, Math.round((totalCents / threshold) * 100)));
    var fill = bar.querySelector('[data-fsb-fill]');
    var textEl = bar.querySelector('[data-fsb-text]');
    var trackEl = bar.querySelector('[data-fsb-track]');
    var noteEl = bar.querySelector('[data-fsb-note]');

    if (noteEl) noteEl.hidden = !hasExcludedItems;
    if (textEl) textEl.hidden = hasExcludedItems;
    if (trackEl) trackEl.hidden = hasExcludedItems;

    if (hasExcludedItems) {
      bar.classList.remove('is-reached');
      if (fill) fill.style.width = '0%';
      return;
    }

    if (remaining <= 0) {
      bar.classList.add('is-reached');
      if (fill) fill.style.width = '100%';
      if (textEl) {
        var okText = bar.getAttribute('data-success-text') || '';
        /* R63b: 值没变不写 —— 重建文本节点会在滑动中重排抽屉并唤醒其他观察器 */
        if (textEl.textContent !== okText) textEl.textContent = okText;
        /* R65d(评审 S0): 达标分支必须作废进度快照, 否则退回同一差额时写入被误跳过, 文字冻结在 unlocked */
        textEl._fsbLast = null;
      }
    } else {
      bar.classList.remove('is-reached');
      if (fill) fill.style.width = percent + '%';
      if (textEl) {
        var tpl = escapeHtml(bar.getAttribute('data-progress-text') || '');
        var moneyFormat = bar.getAttribute('data-money-format') || (window.btyGlobals && window.btyGlobals.money_format);
        var amount = formatMoney(remaining, moneyFormat);
        var html = tpl.replace('[amount]', '<span class="fsb-amount">' + amount + '</span>');
        if (textEl._fsbLast !== html) { textEl._fsbLast = html; textEl.innerHTML = html; }
      }
    }
  }

  var fetching = false;
  var pendingRefresh = false;
  /* R63b: 触摸进行中挂起刷新 —— 手指还在屏上时改抽屉 DOM 会打断 iOS 滚动手势 */
  var fsbTouching = false;
  var fsbWantRefresh = false;
  document.addEventListener('touchstart', function () { fsbTouching = true; }, { passive: true });
  function fsbTouchDone() { fsbTouching = false; if (fsbWantRefresh) { fsbWantRefresh = false; scheduleRefresh(); } }
  document.addEventListener('touchend', fsbTouchDone, { passive: true });
  document.addEventListener('touchcancel', fsbTouchDone, { passive: true });
  function refreshBars() {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    /* R69: 抽屉头部件数([data-bl-cart-count])搭同一趟 cart.js 同步 —— theme.js 加减件只换
       .side-cart-content, 头部在外面会冻结; 清空车时 footer/估价块全被移除, 只有这条路还活着 */
    if (!bars.length && !document.querySelector('[data-bl-cart-count]')) return;
    if (fsbTouching) {
      fsbWantRefresh = true;
      return;
    }
    if (fetching) {
      pendingRefresh = true;
      return;
    }
    fetching = true;
    window.blCartFetch(true) /* R75: 本刷新由购物车变更触发, 必须新鲜数据 */
      .then(function (cart) {
        /* R81(验收 P1): GWP 资格金额剔除赠品行自身 —— 全价赠品会把车值撑过门槛,
           形成"赠品自己解锁自己"的自我污染; $0 行剔除无影响 */
        var gwpAdjusted = cart;
        var bar0 = document.querySelector('[data-free-shipping-bar]');
        if (bar0) {
          var gg1 = bar0.getAttribute('data-gwp-g1'), gg2 = bar0.getAttribute('data-gwp-g2'), gg3 = bar0.getAttribute('data-gwp-g3');
          var giftSum = 0;
          (cart.items || []).forEach(function (it) {
            var v = String(it.variant_id);
            if (v === gg1 || v === gg2 || v === gg3) giftSum += it.final_line_price || 0;
          });
          if (giftSum > 0) {
            gwpAdjusted = {};
            for (var gk in cart) { gwpAdjusted[gk] = cart[gk]; }
            gwpAdjusted.total_price = Math.max(0, (cart.total_price || 0) - giftSum);
          }
        }
        document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
          var eligibleCart = getEligibleCartTotal(cart, bar);
          updateBar(bar, eligibleCart.total, eligibleCart.hasExcludedItems, gwpAdjusted);
        });
        var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (n !== null) {
          var label = n === 0 ? '' : n + (n === 1 ? ' item' : ' items');
          document.querySelectorAll('[data-bl-cart-count]').forEach(function (el) {
            if (el.textContent.trim() !== label) el.textContent = label;
          });
        }
        /* R77: 赠品哨兵每轮跑(独立于档位模式 —— 掉到免邮线下警示也要在) */
        document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
          gwpGiftWarn(bar, cart);
        });
        /* R78b: 角标面板开着时同车更新(R81: 同用剔赠品后的资格金额) */
        var fabOpen = document.querySelector('[data-bl-gwp-fab].is-open');
        if (fabOpen) fabSync(gwpAdjusted);
        /* R92: 抽屉/cart 页进度条里的三档列表每轮同步(锁定/Add/在车/Swap 全状态) ——
           不依赖 applyGwp 路径, 未达免邮线的锁定态回退也靠这轮 */
        document.querySelectorAll('[data-free-shipping-bar] [data-gwp-tiers]').forEach(function (tl) {
          syncTiers(tl, gwpAdjusted, gwpAdjusted.total_price || 0);
        });
      })
      .catch(function () {})
      .finally(function () {
        fetching = false;
        if (pendingRefresh) {
          pendingRefresh = false;
          refreshBars();
        }
      });
  }

  var debounceTimer = null;
  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refreshBars, 300);
  }

  function isInsideBar(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    /* R69: 自己写的件数文本也豁免, 防"写件数→观察器又触发→再拉一趟"的空转(手册陷阱#32 同族) */
    /* R98(审查): estimate 模块的写入也豁免 —— 两观察器互监对方输出会让每次购物车操作多空转一轮 */
    return !!(el && el.closest && (el.closest('[data-free-shipping-bar]') || el.closest('[data-bl-cart-count]') || el.closest('[data-bl-cart-estimate]') || el.closest('[data-bl-cart-estimate-page]')));
  }

  function observe(node) {
    if (!node || node._fsbObserved) return;
    node._fsbObserved = true;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (!isInsideBar(mutations[i].target)) {
          scheduleRefresh();
          return;
        }
      }
    });
    mo.observe(node, { childList: true, subtree: true, characterData: true });
  }

  /* R76: 解锁档一键加赠品 —— POST /cart/add.js 后照抄 theme.js 的局部刷新序列
     (拉 side-cart section 换内容区+total-price, 再调 theme.js 全局重绑), 抽屉不关不跳页 */
  var giftAdding = false;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fsb-gift]') : null;
    if (!btn || giftAdding) return;
    var giftId = parseInt(btn.getAttribute('data-gift-id'), 10);
    if (!giftId) return;
    giftAdding = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: giftId, quantity: 1 }] })
    }).then(function (r) {
      if (r.status === 422) throw new Error('soldout'); /* R81: 售罄竞态 —— 明示不静默 */
      if (!r.ok) throw new Error('add failed');
      return blDrawerRefresh();
    }).then(function () {
      btn.hidden = true;
      var bar = btn.closest('[data-free-shipping-bar]');
      var done = bar ? bar.querySelector('[data-fsb-gift-done]') : null;
      if (done) done.hidden = false;
      scheduleRefresh();
    }).catch(function (err) {
      if (err && err.message === 'soldout') { btn.textContent = 'Sold out'; btn.disabled = true; }
      else { btn.textContent = label; } /* 网络类失败还原可重试 */
    }).finally(function () { giftAdding = false; });
  });

  /* R92: 换赠委托 —— [data-fsb-swap]: fresh cart 里清掉全部赠品行(update.js 按当前 key,
     R91 同款防 stale-key), 再加目标赠品(data-gift-id 空 = 换成礼品卡 = 纯移除, 结账后自动发)。 */
  var giftSwapping = false;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fsb-swap]') : null;
    if (!btn || giftSwapping) return;
    giftSwapping = true;
    var newId = parseInt(btn.getAttribute('data-gift-id'), 10) || null;
    var label = btn.textContent;
    btn.textContent = 'Swapping…';
    window.blCartFetch(true).then(function (cart) {
      var bar = document.querySelector('[data-free-shipping-bar]');
      var g1 = bar ? bar.getAttribute('data-gwp-g1') : null;
      var g2 = bar ? bar.getAttribute('data-gwp-g2') : null;
      var g3 = bar ? bar.getAttribute('data-gwp-g3') : null;
      var updates = {};
      (cart.items || []).forEach(function (it) {
        var vid = String(it.variant_id);
        if (vid === g1 || vid === g2 || vid === g3) updates[it.key] = 0;
      });
      if (!Object.keys(updates).length) return Promise.resolve();
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }).then(function () {
      if (!newId) return null;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: newId, quantity: 1 }] })
      }).then(function (r) {
        if (r.status === 422) throw new Error('soldout');
        if (!r.ok) throw new Error('add failed');
      });
    }).then(function () {
      return blDrawerRefresh();
    }).then(function () {
      btn.textContent = label;
      scheduleRefresh();
    }).catch(function (err) {
      if (err && err.message === 'soldout') { btn.textContent = 'Sold out'; btn.disabled = true; }
      else { btn.textContent = label; }
      scheduleRefresh(); /* 半程失败(已移除未加上)也要把状态刷正 */
    }).finally(function () { giftSwapping = false; });
  });

  /* R77: 局部刷新序列(照抄 theme.js: 换内容区+total-price+全局重绑) —— 加赠/移除共用。
     R81(验收 P1): /cart 页没有抽屉可刷 —— 商品表/汇总栏是 main-cart 模板渲染,
     局部替换重绑链太深, 整页刷新最可靠(与原生表单提交同体验)。 */
  function blDrawerRefresh() {
    if (document.querySelector('.cart-page-section')) {
      location.reload();
      return new Promise(function () {}); /* reload 中断后续链 */
    }
    return fetch('/?sections=side-cart').then(function (r) { return r.json(); }).then(function (sec) {
      if (!sec || !sec['side-cart']) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = sec['side-cart'];
      var freshContent = tmp.querySelector('.side-cart-content');
      var curContent = document.querySelector('.side-cart-content');
      if (freshContent && curContent) curContent.innerHTML = freshContent.innerHTML;
      var freshTotal = tmp.querySelector('.side-cart-footer .total-price');
      var curTotal = document.querySelector('.side-cart-footer .total-price');
      if (freshTotal && curTotal) curTotal.innerHTML = freshTotal.innerHTML;
      if (typeof window.btyQuantityButton === 'function') window.btyQuantityButton();
      if (typeof window.btyUpdateProductQuantity === 'function') window.btyUpdateProductQuantity();
    });
  }

  /* R77: 哨兵警示行的一键移除(按 line key 精确删行) */
  var giftRemoving = false;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fsb-warn-remove]') : null;
    if (!btn || giftRemoving) return;
    var key = btn.getAttribute('data-remove-key');
    if (!key) return;
    giftRemoving = true;
    var label = btn.textContent;
    btn.textContent = 'Removing…';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) {
      if (!r.ok) throw new Error('change failed');
      return blDrawerRefresh();
    }).then(function () {
      var warn = btn.closest('[data-fsb-warn]');
      if (warn) warn.hidden = true;
      scheduleRefresh();
    }).catch(function () {
      btn.textContent = label;
    }).finally(function () { giftRemoving = false; });
  });

  /* R78b: 浮动角标展开面板 —— 三档赠品状态机。三选一规则: 只有当前最高解锁档给 Add,
     低档 Passed、高档锁; 任一赠品已在车($0 或全价)不再给 Add(哨兵负责全价警示)。 */
  function fabSync(cart) {
    var fab = document.querySelector('[data-bl-gwp-fab]');
    if (!fab || !cart) return;
    var total = cart.total_price || 0;
    var bar = document.querySelector('[data-free-shipping-bar]');
    var cur = total >= 50000 ? 3 : total >= 30000 ? 2 : total >= 15000 ? 1 : 0;
    var moneyFormat = (bar && bar.getAttribute('data-money-format')) || (window.btyGlobals && window.btyGlobals.money_format);
    var statusEl = fab.querySelector('[data-fab-status]');
    var fillEl = fab.querySelector('[data-fab-fill]');
    var next = cur === 0 ? 15000 : cur === 1 ? 30000 : cur === 2 ? 50000 : 0;
    var msg;
    /* R94: 卡版文案 */
    if (cur === 3) { msg = 'All tiers unlocked — grab your free $50 gift card 🎉'; }
    else {
      var names = { 15000: 'a free $15 gift card', 30000: 'the $25 gift card', 50000: 'the $50 gift card' };
      msg = formatMoney(next - total, moneyFormat) + ' more to unlock ' + names[next] + '.';
    }
    if (statusEl && statusEl.textContent !== msg) statusEl.textContent = msg;
    if (fillEl) fillEl.style.width = (cur === 3 ? 100 : Math.min(100, Math.round((total / next) * 100))) + '%';
    /* R92: tier 行状态统一走 syncTiers(抽屉列表同一状态机, 含 Swap 换赠) */
    var tiers = fab.querySelector('[data-gwp-tiers]');
    if (tiers) syncTiers(tiers, cart, total);
  }
  function fabInit() {
    var fab = document.querySelector('[data-bl-gwp-fab]');
    if (!fab || fab.__blInit) return;
    fab.__blInit = true;
    var closed = false;
    try { closed = sessionStorage.getItem('blgwp_fab_closed') === '1'; } catch (e) {}
    if (!closed) fab.hidden = false;
    var panel = fab.querySelector('[data-bl-gwp-fab-panel]');
    var toggle = fab.querySelector('[data-bl-gwp-fab-toggle]');
    if (toggle && panel) toggle.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      fab.classList.toggle('is-open', !panel.hidden);
      if (!panel.hidden) window.blCartFetch(true).then(fabSync).catch(function () {});
    });
    var x = fab.querySelector('[data-bl-gwp-fab-close]');
    if (x) x.addEventListener('click', function () {
      fab.hidden = true;
      try { sessionStorage.setItem('blgwp_fab_closed', '1'); } catch (e) {}
    });
  }

  function init() {
    observe(document.querySelector('.side-cart'));
    observe(document.querySelector('.cart-page-section'));
    fabInit();
    /* R73: gwp 开启(或 QA 钩子)时首刷一次 —— Liquid 初始渲染只覆盖设置态,
       ?blgwp=1 预览态靠这次首刷接管; 其余情况不加载页额外请求 */
    if (/[?&]blgwp=1/.test(location.search) || document.querySelector('[data-free-shipping-bar][data-gwp="1"]')) {
      scheduleRefresh();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== Borderline Outdoor — store landing page init (Phase 3) ===== */
(function(){
  /* 2026-09-25: optional Friday override fo/fc (data-fri-open/close on .bl-sp) — Newmarket Fri 1–7 PM, Sat/Sun 12–8 PM.
     fmt also prints half hours (9.5 -> 9:30 AM; was "9.5 AM"). */
  function blStatus(open,close,days,fo,fc){
    var now=new Date(new Date().toLocaleString('en-US',{timeZone:'America/Toronto'}));
    var d=now.getDay(),h=now.getHours()+now.getMinutes()/60;
    var od=days==='daily'?[0,1,2,3,4,5,6]:[5,6,0];
    var hrs=function(day){return day===5&&fo>=0&&fc>0?[fo,fc]:[open,close];};
    var fmt=function(hr){var ap=hr>=12?'PM':'AM';var hh=Math.floor(hr)%12;if(hh===0)hh=12;var m=Math.round((hr%1)*60);return hh+(m?':'+(m<10?'0':'')+m:'')+' '+ap;};
    var nm=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var t=hrs(d);
    if(od.indexOf(d)>-1&&h>=t[0]&&h<t[1])return{open:true,text:'Open now · Closes '+fmt(t[1])};
    for(var i=0;i<8;i++){var cd=(d+i)%7;if(od.indexOf(cd)>-1){var o=hrs(cd)[0];if(i===0&&h<o)return{open:false,text:'Closed · Opens '+fmt(o)};if(i>0)return{open:false,text:'Closed · Opens '+nm[cd]+' '+fmt(o)};}}
    return{open:false,text:'Closed'};
  }
  function initSP(){
    var roots=document.querySelectorAll('.bl-sp');
    for(var i=0;i<roots.length;i++){
      var root=roots[i];
      var st=blStatus(parseFloat(root.getAttribute('data-open')),parseFloat(root.getAttribute('data-close')),root.getAttribute('data-days'),parseFloat(root.getAttribute('data-fri-open')),parseFloat(root.getAttribute('data-fri-close')));
      var b=root.querySelector('.bl-sp__status'),t=root.querySelector('.bl-sp__statustxt');
      if(t)t.textContent=st.text;
      if(b){b.classList.remove('bl-badge--open','bl-badge--closed');b.classList.add(st.open?'bl-badge--open':'bl-badge--closed');}
      var track=root.querySelector('.bl-sp__gal-track');
      if(track){var by=(function(tr){return function(dir){tr.scrollBy({left:dir*tr.clientWidth*0.8,behavior:'smooth'});};})(track);var p=root.querySelector('.bl-sp__gal-prev'),n=root.querySelector('.bl-sp__gal-next');if(p)p.onclick=function(){by(-1);};if(n)n.onclick=function(){by(1);};}
    }
  }
  if(document.readyState!=='loading'){initSP();}else{document.addEventListener('DOMContentLoaded',initSP);}
  setTimeout(initSP,600);
})();

/* ===== Borderline Outdoor — homepage hero carousel (sections/bl-store-hero.liquid) ===== */
(function () {
  'use strict';
  /* R64c(审计 L0): visibilitychange 只注册一次, 经 blHeroActive 间接引用当前实例 ——
     原来每次 init 都新挂监听+旧 interval 无人清, 编辑器里越编越卡 */
  var blHeroActive = { stop: null, play: null };
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { if (blHeroActive.stop) { blHeroActive.stop(); } }
    else if (blHeroActive.play) { blHeroActive.play(); }
  });
  function blHeroStatus(open, close, days) {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));
    var d = now.getDay(), h = now.getHours() + now.getMinutes() / 60;
    var od = days === 'daily' ? [0, 1, 2, 3, 4, 5, 6] : [5, 6, 0];
    var fmt = function (hr) { var ap = hr >= 12 ? 'PM' : 'AM'; var hh = hr % 12; if (hh === 0) hh = 12; return hh + ' ' + ap; };
    var nm = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    if (od.indexOf(d) > -1 && h >= open && h < close) return { open: true, text: 'Open now · Closes ' + fmt(close) };
    for (var i = 0; i < 8; i++) {
      var cd = (d + i) % 7;
      if (od.indexOf(cd) > -1) {
        if (i === 0 && h < open) return { open: false, text: 'Closed · Opens ' + fmt(open) };
        if (i > 0) return { open: false, text: 'Closed · Opens ' + nm[cd] + ' ' + fmt(open) };
      }
    }
    return { open: false, text: 'Closed' };
  }
  function initBLHero() {
    var root = document.querySelector('[data-bl-hero]');
    if (!root || root.getAttribute('data-bl-ready') === '1') return;
    root.setAttribute('data-bl-ready', '1');
    var slides = root.querySelectorAll('.bl-hero__slide');
    var dots = root.querySelectorAll('.bl-hero__dots button');
    var n = slides.length, cur = 0, timer = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards = root.querySelectorAll('.bl-hs');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var st = blHeroStatus(parseFloat(card.getAttribute('data-open')), parseFloat(card.getAttribute('data-close')), card.getAttribute('data-days'));
      var t = card.querySelector('.bl-hs__statustxt');
      if (t) t.textContent = st.text;
      var b = card.querySelector('.bl-hs__status');
      if (b) { b.classList.remove('bl-badge--open', 'bl-badge--closed'); b.classList.add(st.open ? 'bl-badge--open' : 'bl-badge--closed'); }
    }
    function go(i) {
      cur = (i + n) % n;
      for (var k = 0; k < n; k++) {
        slides[k].classList.toggle('is-active', k === cur);
        if (dots[k]) dots[k].classList.toggle('is-on', k === cur);
      }
    }
    function next() { go(cur + 1); }
    function prev() { go(cur - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() { if (reduced) return; stop(); timer = setInterval(next, 6500); }
    var pv = root.querySelector('.bl-hero__prev'), nx = root.querySelector('.bl-hero__next');
    if (pv) pv.addEventListener('click', function () { prev(); play(); });
    if (nx) nx.addEventListener('click', function () { next(); play(); });
    for (var di = 0; di < dots.length; di++) {
      (function (i) { dots[i].addEventListener('click', function () { go(i); play(); }); })(di);
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    blHeroActive.stop = stop; blHeroActive.play = play;
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { if (dx < 0) { next(); } else { prev(); } }
      x0 = null; play();
    }, { passive: true });
    play();
  }
  if (document.readyState !== 'loading') { initBLHero(); } else { document.addEventListener('DOMContentLoaded', initBLHero); }
  setTimeout(initBLHero, 600);
  document.addEventListener('shopify:section:load', function () {
    if (blHeroActive.stop) { blHeroActive.stop(); } /* R64c: 重建前先杀旧实例 interval */
    var r = document.querySelector('[data-bl-hero]');
    if (r) r.setAttribute('data-bl-ready', '0');
    initBLHero();
  });
})();

/* ---- R64(审计 C2): bl-cart-estimate 同步脚本(自 snippet 迁入, 原文见 git/备份) ----
   必须在每页可用: 空车进站的会话, 首次加购后 theme.js 以 innerHTML 注入抽屉,
   注入的 <script> 不执行 —— 只有随 custom.js 常驻才能接管刷新。 */
/* R50c: 预估块随购物车加减实时重算 —— 同 free-shipping-bar 的观察器触发,
   但刷新走 Section Rendering API 整段重渲染(Liquid 全判定层, 不在 JS 复刻规则)。 */
(function(){
  if (window.__blCestBound) return; window.__blCestBound = true;
  var fetching = false, pending = false, timer = null;
  /* R63: 上次应用的 HTML 快照 —— 内容没变就不换节点。此前每次都 replaceWith,
     换节点在父级产生 childList 变异, inSelf 豁免不到父级 → 观察器再触发 → 350ms 无限
     自循环重排, 移动端滑动被反复打断(老板"一直向下滑动就会卡住"的病根之一) */
  var lastHtml = { d: null, p: null };
  var touching = false, wantSwap = false;
  function swap(){
    var drawerEl = document.querySelector('[data-bl-cart-estimate]');
    var pageEl = document.querySelector('[data-bl-cart-estimate-page]');
    if (!drawerEl && !pageEl) return;
    if (touching){ wantSwap = true; return; } /* R63: 手指还在屏上, 等 touchend 再换 */
    if (fetching){ pending = true; return; }
    fetching = true;
    var ids = [];
    if (drawerEl) ids.push('side-cart');
    if (pageEl) ids.push('main-cart');
    /* R69 实测: 带 Accept:application/json 时集合路由走内容协商直接 404(空体) ——
       估价同步在集合页从未生效过, 只是被 catch 吞掉; Section Rendering API 靠
       ?sections= 参数就返回 JSON, 裸请求全路由 200 */
    fetch(location.pathname + '?sections=' + ids.join(','))
      .then(function(r){ return r.json(); })
      .then(function(sec){
        var tmp = document.createElement('div');
        if (drawerEl && sec['side-cart'] !== undefined){
          tmp.innerHTML = sec['side-cart'] || '';
          var n = tmp.querySelector('[data-bl-cart-estimate]');
          var h = n ? n.outerHTML : '';
          if (h !== lastHtml.d){
            lastHtml.d = h;
            /* R63b: 折叠件换节点时保留用户的展开状态(比对用服务器原样 HTML, open 后设不影响跳过判定) */
            if (n && n.tagName === 'DETAILS' && drawerEl.tagName === 'DETAILS') n.open = drawerEl.open;
            if (n) drawerEl.replaceWith(n); else drawerEl.remove();
          }
        }
        if (pageEl && sec['main-cart'] !== undefined){
          tmp.innerHTML = sec['main-cart'] || '';
          var n2 = tmp.querySelector('[data-bl-cart-estimate-page]');
          var h2 = n2 ? n2.outerHTML : '';
          if (n2 && h2 !== lastHtml.p){ lastHtml.p = h2; pageEl.replaceWith(n2); }
          /* R65d(评审 K15): 吸底结账条在全部 AJAX 模块之外, 改数量后总价/副标题冻结 —— 借同一次
             section 拉取顺带同步 */
          ['.bl-mobilebar__total', '.bl-mobilebar__sub'].forEach(function (sel) {
            var fresh = tmp.querySelector(sel), cur = document.querySelector(sel);
            if (fresh && cur && cur.textContent !== fresh.textContent) cur.textContent = fresh.textContent;
          });
        }
      })
      .catch(function(){})
      .finally(function(){
        fetching = false;
        if (pending){ pending = false; swap(); }
      });
  }
  function sched(){ clearTimeout(timer); timer = setTimeout(swap, 350); }
  function inSelf(node){
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    /* R69: fsb 模块写头部件数的 characterData 变异也豁免, 防每次改车多空转一趟 section 拉取 */
    /* R98(审查): fsb 进度条的写入也豁免(对称互豁免, 同上) */
    return !!(el && el.closest && (el.closest('[data-bl-cart-estimate]') || el.closest('[data-bl-cart-estimate-page]') || el.closest('[data-bl-cart-count]') || el.closest('[data-free-shipping-bar]')));
  }
  /* R63: swap 自己换节点产生的 childList 变异(增删的正是预估节点)也要豁免 */
  function isEstNode(nd){
    return !!(nd && nd.nodeType === 1 && nd.hasAttribute &&
      (nd.hasAttribute('data-bl-cart-estimate') || nd.hasAttribute('data-bl-cart-estimate-page')));
  }
  function onlyEstChange(m){
    if (m.type !== 'childList') return false;
    var list = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
    if (!list.length) return false;
    for (var j = 0; j < list.length; j++){ if (!isEstNode(list[j])) return false; }
    return true;
  }
  function watch(node){
    if (!node || node.__blCestObs) return;
    node.__blCestObs = true;
    new MutationObserver(function(ms){
      for (var i = 0; i < ms.length; i++){
        if (!inSelf(ms[i].target) && !onlyEstChange(ms[i])){ sched(); return; }
      }
    }).observe(node, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('touchstart', function(){ touching = true; }, { passive: true });
  function touchDone(){ touching = false; if (wantSwap){ wantSwap = false; sched(); } }
  document.addEventListener('touchend', touchDone, { passive: true });
  document.addEventListener('touchcancel', touchDone, { passive: true });
  function init(){
    watch(document.querySelector('.side-cart'));
    watch(document.querySelector('.cart-page-section'));
  }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* ---- R67: blm mega 移动端子类目展开脚本(自 mega-menu.liquid 迁入, __blmMega 守卫防与旧内联并存双绑) ---- */
(function(){if(window.__blmMega)return;window.__blmMega=1;
document.addEventListener('click',function(e){
 var t=e.target.closest('.blm-tgl');if(!t)return;
 e.preventDefault();e.stopPropagation();
 var li=t.closest('.blm-li');if(!li)return;
 var ex=li.classList.toggle('blm-ex');
 t.setAttribute('aria-expanded',ex?'true':'false');
});})();

/* ---- R68c: 常驻式购物车挽留邮箱采集(自 bl-save-cart.liquid 迁入, 常驻防 innerHTML 注入丢监听) ---- */
(function(){
	'use strict';
	if (window.__blSaveCart) return;
	window.__blSaveCart = 1;
	var COOKIE_DONE = 'blexit_done', COOKIE_SUP = 'blexit_sup';
	function getCookie(n){
		try { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? m[1] : null; } catch(e){ return null; }
	}
	function setCookie(n, v, days){
		try { document.cookie = n + '=' + v + '; path=/; max-age=' + (days * 86400) + '; SameSite=Lax'; } catch(e){}
	}
	/* cart_recovery UTM 进站 → 7 天压制(落地页即写) */
	try { if (/utm_[a-z_]+=[^&]*cart[_-]?recovery/i.test(location.search)) setCookie(COOKIE_SUP, '1', 7); } catch(e){}

	function ga(ev, val){
		try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: ev, cart_value: val }); } catch(e){}
	}
	function markDone(root){ root.classList.add('is-done'); var d = root.querySelector('[data-bl-savecart-done]'); if (d) d.hidden = false; }
	function suppressed(){ return !!(getCookie(COOKIE_DONE) || getCookie(COOKIE_SUP)); }

	/* 状态渲染 + 首次进视口计 view —— 抽屉被 theme.js 整体重建后新节点会再流入 initBlocks */
	var viewSent = false;
	function initBlocks(){
		document.querySelectorAll('[data-bl-savecart]').forEach(function(root){
			if (root.__blInit) return;
			root.__blInit = true;
			/* R69: 抽屉版 root 里包着 View cart 行 —— 压制/回访态改类名(CSS 只藏挽留件),
			   display:none 会连 View cart 一起藏掉; 页版 CSS 仍整块隐藏, 行为不变。
			   R75(上线前审查): 本会话刚提交过(sessionStorage 标记)时不加 is-restored ——
			   否则提交后加一件货、抽屉整重建, "Cart link sent" 确认被回访态静默吞掉 */
			if (getCookie(COOKIE_DONE)){
				markDone(root);
				var justSent = false;
				try { justSent = sessionStorage.getItem('blexit_justsent') === '1'; } catch(e){}
				if (!justSent) root.classList.add('is-restored');
				return;
			}
			if (getCookie(COOKIE_SUP)){ root.classList.add('is-sup'); return; }
			if (viewSent || !('IntersectionObserver' in window)) return;
			try {
				var io = new IntersectionObserver(function(es){
					es.forEach(function(en){
						if (en.isIntersecting && !viewSent){
							viewSent = true;
							var p = window.blCartFetch ? window.blCartFetch()
								: fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); });
							p.then(function(c){ ga('exit_modal_view', c && c.total_price ? Math.round(c.total_price) / 100 : 0); }).catch(function(){});
							io.disconnect();
						}
					});
				}, { threshold: .4 });
				io.observe(root);
			} catch(e){}
		});
	}
	initBlocks();
	try { new MutationObserver(initBlocks).observe(document.body, { childList: true, subtree: true }); } catch(e){}

	/* R68d: 购物车页区块位于外层 <form id="cart"> 内 —— 嵌套 form 被浏览器解析器丢弃,
	   submit 委托匹配不上且 submit 按钮会误交外层表单(= 意外触发结账 POST)。
	   改无 form 结构: 按钮点击 + 输入框 Enter 两个委托入口, 统一走 submitSave(root)。 */
	function submitSave(root){
		var emailEl = root.querySelector('.bl-savecart__email');
		var err = root.querySelector('[data-bl-savecart-err]');
		if (!emailEl || !err) return;
		var email = (emailEl.value || '').trim();
		if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){ err.hidden = false; emailEl.focus(); return; }
		err.hidden = true;
		var btn = root.querySelector('.bl-savecart__btn');
		if (!btn.__blLabel) btn.__blLabel = btn.textContent; /* R69: 抽屉版按钮是 Email me, 失败恢复不能写死 */
		btn.disabled = true; btn.textContent = 'Saving…';
		var chkEl = root.querySelector('.bl-savecart__chk'); /* R69: 抽屉版无勾选框(设计稿砍), 空指针守卫 */
		var optIn = chkEl ? chkEl.checked : false;
		var token = (root.getAttribute('data-sf-token') || '').trim();

		var cartP = window.blCartFetch ? window.blCartFetch()
			: fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); });
		cartP.then(function(cart){
			var cartVal = cart && cart.total_price ? Math.round(cart.total_price) / 100 : 0;
			var biOk = false;
			var steps = [];
			if (token && /^[A-Za-z0-9]{10,}$/.test(token) && cart && cart.token){
				try {
					steps.push(
						fetch('/api/2026-01/graphql.json', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
							body: JSON.stringify({
								query: 'mutation($id:ID!,$bi:CartBuyerIdentityInput!){cartBuyerIdentityUpdate(cartId:$id,buyerIdentity:$bi){cart{id}userErrors{message}}}',
								variables: { id: 'gid://shopify/Cart/' + cart.token, bi: { email: email } }
							})
						}).then(function(r){ return r.json(); }).then(function(d){
							var res = d && d.data && d.data.cartBuyerIdentityUpdate;
							if (res && res.cart && (!res.userErrors || !res.userErrors.length)) biOk = true;
						}).catch(function(){})
					);
				} catch(e){}
			}
			if (optIn){
				var fd = new URLSearchParams();
				fd.set('form_type', 'customer'); fd.set('utf8', '✓');
				fd.set('contact[email]', email); fd.set('contact[tags]', 'newsletter,save-cart');
				steps.push(fetch('/contact', {
					method: 'POST',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: fd.toString(), keepalive: true
				}).then(function(r){
					if (r && r.redirected && r.url && r.url.indexOf('/challenge') > -1) ga('exit_modal_subscribe_blocked', cartVal);
				}).catch(function(){}));
			}
			var gone = false;
			function finish(){
				if (gone) return; gone = true;
				setCookie(COOKIE_DONE, '1', 30);
				try { sessionStorage.setItem('blexit_justsent', '1'); } catch(e){} /* R75: 本会话确认态跨抽屉重建保留 */
				ga('exit_modal_submit', cartVal);
				if (biOk){
					/* token 通道成功: 邮箱已随购物车落库 —— 原地确认, 不打断用户 */
					document.querySelectorAll('[data-bl-savecart]').forEach(markDone);
					return;
				}
				/* 无 token / 落库失败: permalink 预填是唯一捕获通道(车干净才用) */
				var target = '/checkout';
				if (cart && cart.items && cart.items.length){
					var clean = cart.items.every(function(it){
						var hasProps = it.properties && Object.keys(it.properties).length > 0;
						return !hasProps && !it.selling_plan_allocation;
					}) && !cart.note;
					if (clean){
						var parts = cart.items.map(function(it){ return it.variant_id + ':' + it.quantity; });
						target = '/cart/' + parts.join(',') + '?checkout[email]=' + encodeURIComponent(email);
					}
				}
				window.location.href = target;
			}
			var t = setTimeout(finish, 1800);
			Promise.all(steps).then(function(){ clearTimeout(t); finish(); }, function(){ clearTimeout(t); finish(); });
		}).catch(function(){
			btn.disabled = false; btn.textContent = btn.__blLabel || 'Save my cart';
		});
	}
	document.addEventListener('click', function(e){
		var b = e.target && e.target.closest ? e.target.closest('.bl-savecart__btn') : null;
		if (!b) return;
		e.preventDefault();
		var root = b.closest('[data-bl-savecart]');
		if (root) submitSave(root);
	});
	/* R69: 抽屉版一行入口 —— 点开才展开邮箱(委托, 抽屉 innerHTML 重建后照常生效) */
	document.addEventListener('click', function(e){
		var t = e.target && e.target.closest ? e.target.closest('.bl-savecart__entry') : null;
		if (!t) return;
		e.preventDefault();
		var root = t.closest('[data-bl-savecart]');
		if (!root) return;
		root.classList.add('is-open');
		var em = root.querySelector('.bl-savecart__email');
		if (em) { try { em.focus(); } catch(err){} }
	});
	document.addEventListener('keydown', function(e){
		if (e.key !== 'Enter') return;
		var t = e.target;
		if (!t || !t.classList || !t.classList.contains('bl-savecart__email')) return;
		e.preventDefault(); /* 防触发外层 cart form 原生提交 */
		var root = t.closest('[data-bl-savecart]');
		if (root) submitSave(root);
	});
})();

/* ---- R70(转化批次③): Cloud Boundar 分组变体选择器 ----
   渐进增强: 找到主 picker 的 name="Part" radio 组才挂载(顶替原生文字按钮),
   找不到则卡片组保持 hidden、原生组照旧。点卡片 = 代理点原生 radio ——
   theme.js onchange 原生链(价格/图廊/URL/加购钮/粘性桥)全部照常(R66 桥同款契约)。
   高亮真值源 = radio:checked; change 冒泡委托同步(粘性条回写主 radio 也带得动)。 */
(function(){
	'use strict';
	if (window.__blPartPicker) return;
	window.__blPartPicker = 1;
	var pickerEl = null;

	function sync(){
		if (!pickerEl) return;
		var checked = pickerEl.querySelector('input.field-value[name="Part"]:checked');
		var val = checked ? checked.value : null;
		document.querySelectorAll('[data-bl-part-picker] .bl-pp__card').forEach(function(c){
			c.classList.toggle('is-active', !!val && c.getAttribute('data-pp-value') === val);
		});
	}

	function init(){
		var root = document.querySelector('[data-bl-part-picker]');
		if (!root || root.__blInit) return;
		/* root 与 product-summary 同层兄弟 —— 从父级找主买盒 picker, 避开 quickview 的同构结构 */
		var scope = root.parentElement;
		var picker = scope ? scope.querySelector('.product-variants') : null;
		if (!picker) return;
		var radios = picker.querySelectorAll('input.field-value[name="Part"]');
		if (!radios.length) return; /* 结构变了 → 不挂载, 原生组照旧 */
		var field = radios[0].closest('.variant-field');
		if (!field) return;
		root.__blInit = true;
		pickerEl = picker;
		field.classList.add('bl-pp-replaced'); /* CSS 藏 field-wrap, 保留 "Part: <选中值>" 标题行 */
		field.parentNode.insertBefore(root, field.nextSibling);
		root.hidden = false;
		sync();
	}

	document.addEventListener('click', function(e){
		var card = e.target && e.target.closest ? e.target.closest('.bl-pp__card') : null;
		if (!card || card.disabled || !pickerEl) return;
		var val = card.getAttribute('data-pp-value');
		var radios = pickerEl.querySelectorAll('input.field-value[name="Part"]');
		for (var i = 0; i < radios.length; i++){
			if (radios[i].value === val){
				if (!radios[i].checked) radios[i].click(); /* 原生链全带动 */
				break;
			}
		}
		sync();
	});
	document.addEventListener('change', function(e){
		if (pickerEl && e.target && e.target.nodeType === 1 && pickerEl.contains(e.target)) sync();
	});
	if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
	setTimeout(init, 600); /* 兜底: 主题脚本晚构 DOM 的场景(与 bl-store 系模块同款保险) */
})();

/* ---- R84: content-visibility 与 swiper 测量兜底 ----
   custom.css 给隐藏弹窗/快搜面板加了 content-visibility:hidden、给折叠线下轮播 section
   加了 c-v:auto —— 子树跳布局意味着 theme.js 页面加载时 init 的 swiper 测量为 0。
   Swiper 默认 updateOnWindowResize:true, 所以在 c-v 解除的时机(开弹窗/开快搜/section
   滚近视口)派发一次 resize 即完成重测量。双 rAF 确保翻类后的布局已生效。 */
(function(){
	'use strict';
	var kick = function(){
		requestAnimationFrame(function(){ requestAnimationFrame(function(){
			window.dispatchEvent(new Event('resize'));
		}); });
	};
	/* capture 阶段先内联解除 c-v 再派发 resize —— theme.js 的 onclick 里 input.focus()
	   在 open 类翻上之前执行, 面板还在 c-v:hidden(无布局)时 focus 会静默失败 */
	var unveil = function(sel){
		var el = document.querySelector(sel);
		if (el && el.style.contentVisibility !== 'visible') el.style.contentVisibility = 'visible';
	};
	document.addEventListener('click', function(e){
		if (!e.target || e.target.nodeType !== 1) return;
		if (e.target.closest('.toggle-shopable-popup')){ unveil('.shopable-video-section .shopable-popup'); kick(); }
		else if (e.target.closest('.action-search')){ unveil('.quick-search'); kick(); }
	}, true);
	var init = function(){
		var secs = document.querySelectorAll('.new-product-carousel-section, .bl-apparel-section');
		if (!secs.length || !('IntersectionObserver' in window)) return;
		var io = new IntersectionObserver(function(entries){
			entries.forEach(function(en){
				if (en.isIntersecting){ io.unobserve(en.target); kick(); }
			});
		}, { rootMargin: '200px 0px' });
		secs.forEach(function(s){ io.observe(s); });
	};
	if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* R101: YouTube 描述内嵌延迟加载 —— Liquid 把描述里的 iframe src 改成 data-bl-src(loading=lazy 挡不住 Lighthouse/快网下的预取,
   PDP 白扛 983KB 播放器脚本); 进入视口前 400px 或所在容器显示出来时才补 src。 */
(function () {
  'use strict';
  function arm() {
    var frames = document.querySelectorAll('iframe[data-bl-src]:not([src])');
    if (!frames.length) { return; }
    var load = function (f) { if (!f.getAttribute('src')) { f.setAttribute('src', f.getAttribute('data-bl-src')); } };
    if (!('IntersectionObserver' in window)) { frames.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRect.width > 0 && e.intersectionRect.height > 0) { io.unobserve(e.target); load(e.target); }
      });
    }, { rootMargin: '400px 0px' });
    frames.forEach(function (f) { io.observe(f); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', arm); } else { arm(); }
  document.addEventListener('shopify:section:load', arm);
})();
